var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"payment-fail-page"},[_c('h1',{staticClass:"payment-fail-page__title"},[_vm._v("결제에 실패했습니다.")])])
}]

export { render, staticRenderFns }